export { default } from './NativeSelect';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/NativeSelect/index.js
// module id = 344
// module chunks = 0